"use client";
import Image from "next/image";
import cat from "../../../assets/images/cat.svg";
import chicken from "../../../assets/images/chicken.svg";
import cow from "../../../assets/images/cow.svg";
import dog from "../../../assets/images/dog.svg";
import fish from "../../../assets/images/fish.svg";
import sheep from "../../../assets/images/sheep.svg";
import sideCardCat from "../../../assets/images/sideCardCat.svg";
import sideCardChicken from "../../../assets/images/sideCardChicken.svg";
import sideCardCow from "../../../assets/images/sideCardCow.svg";
import sideCardDog from "../../../assets/images/sideCardDog.svg";
import sideCardFish from "../../../assets/images/sideCardFish.svg";
import sideCardSheep from "../../../assets/images/sideCardSheep.svg";
import backgroundShape1 from "../../../assets/images/backgroundShape1.svg";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/navigation";
import { use, useEffect, useState } from "react";
import Slider from "react-slick";
import sheepProduct from "../../../assets/images/sheepProduct.svg";
import cowsProduct from "../../../assets/images/cowsProduct.svg";
import chickenProduct from "../../../assets/images/chickenProduct.svg";

export default function ProductCategoryPage({ params }) {
  const { t } = useTranslation();
  const unwrappedParams = use(params);
  const paramId = parseInt(unwrappedParams?.id);
  const router = useRouter();
  const [slidesToShow, setSlidesToShow] = useState(1);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setSlidesToShow(window.innerWidth > 768 ? 3 : 1);
    }
  }, []);

  const settings2 = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    cssEase: "linear",
  };

  const categories = [
    { id: 1, image: sheep, title: "sheep" },
    { id: 2, image: chicken, title: "chicken" },
    { id: 3, image: cow, title: "cow" },
    { id: 4, image: fish, title: "fish" },
    { id: 5, image: cat, title: "cat" },
    { id: 6, image: dog, title: "dog" },
  ];
  const tableData = [
    {
      desc: "برای گونه بالغ (مقاوم‌ترند)",
      source: "FDA | ppb",
      max: "30000",
      toxin: "فومونیسین‌ها، مجموع B1 و B2 و B3",
      bg: "bg-white",
    },
    {
      desc: "آفلاتوکسین B1 بسیار سمی و خطرناک",
      source: "FDA | ppb",
      max: "20",
      toxin: "آفلاتوکسین کل",
      bg: "bg-[#F9F9F9]",
    },
    {
      desc: "تحمل بیشتر به دلیل تجزیه در شکمبه",
      source: "FDA | ppb",
      max: "250 تا 500",
      toxin: "زیرالنون",
      bg: "bg-white",
    },
    {
      desc: "مقاومت بیشتر به دلیل تجزیه شکمبه‌ای",
      source: "FDA | ppb",
      max: "250 تا 500",
      toxin: "Ht2 & T2",
      bg: "bg-[#F9F9F9]",
    },
    {
      desc: "مقاومت بیشتر به دلیل تجزیه شکمبه‌ای",
      source: "FDA | ppb",
      max: "5000 تا 10000",
      toxin: "دی اکسی نیوالنول",
      bg: "bg-white",
    },
    {
      desc: "مقاومت بیشتر به دلیل تجزیه شکمبه‌ای",
      source: "FDA | ppb",
      max: "30000",
      toxin: "اکراتوکسین A",
      bg: "bg-[#F9F9F9]",
    },
  ];

  return (
    <div
      style={{
        backgroundColor: "#EAF6FF",
        backgroundImage: `
                   url(${backgroundShape1.src})`,
        backgroundSize: "100% auto",
        backgroundPosition: "top center",
        backgroundRepeat: "repeat",
      }}
      className="flex flex-col gap-8 md:gap-24 h-full bg-transparent w-full font-sans text-[#003477] pb-10"
    >
      <section className="relative flex flex-col md:flex-row w-full justify-center m-auto py-8 gap-16">
        <div className="flex relative w-full md:w-1/3 flex-col justify-center items-center md:items-start gap-10">
          <div className="flex relative w-full flex-col justify-center items-center md:items-start">
            <span className="flex text-center md:text-center rounded-2xl text-xl font-bold gap-3 items-center">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 10.7321C-0.333333 9.96225 -0.333333 8.03775 1 7.26795L13 0.339746C14.3333 -0.430054 16 0.532197 16 2.0718L16 15.9282C16 17.4678 14.3333 18.4301 13 17.6603L1 10.7321Z"
                  fill={
                    paramId === 1
                      ? "#ACD00E"
                      : paramId === 2
                      ? "#E84545"
                      : paramId === 3
                      ? "#43CA71"
                      : paramId === 4
                      ? "#C192FF"
                      : paramId === 5
                      ? "#F7941D"
                      : paramId === 6
                      ? "#3870FF"
                      : "none"
                  }
                />
              </svg>
              {paramId === 1
                ? t("sheep")
                : paramId === 2
                ? t("chicken")
                : paramId === 3
                ? t("cow")
                : paramId === 4
                ? t("fish")
                : paramId === 5
                ? t("cat")
                : paramId === 6
                ? t("dog")
                : ""}
            </span>
            <p>
              {paramId === 1
                ? "گونه دام به طور کلی به انواع مختلف جانوران اهلی که برای اهداف مختلفی مانند تولید گوشت، شیر، پشم، یا کار و باربری پرورش داده می‌شوند، اشاره دارد. این جانوران می‌توانند شامل گاو، گوسفند، بز، اسب، شتر و غیره باشند."
                : paramId === 2
                ? "گونه‌های طیور به پرندگانی اطلاق می‌شود که به طور معمول برای تولید گوشت، تخم، یا پر و به صورت مصنوعی پرورش داده می‌شوند، اما برخی از آن‌ها نیز برای مشاهده نگهداری می‌شوند. طیور شامل طیف وسیعی از پرندگان از جمله مرغ، اردک، غاز، بوقلمون، بلدرچین، و قرقاول هستند."
                : paramId === 3
                ? "گونه دام به طور کلی به انواع مختلف جانوران اهلی که برای اهداف مختلفی مانند تولید گوشت، شیر، پشم، یا کار و باربری پرورش داده می‌شوند، اشاره دارد. این جانوران می‌توانند شامل گاو، گوسفند، بز، اسب، شتر و غیره باشند."
                : paramId === 4
                ? "انواع ماهی پرورشی در ایران و جهان متنوع است و شامل ماهیان گرمابی و سردآبی می‌شود. از جمله ماهیان گرمابی پرورشی می‌توان به کپور معمولی، آمور (کپور علفخوار)، کپور نقره‌ای، و کپور سرگنده اشاره کرد. در میان ماهیان سردآبی پرورشی، قزل‌آلا و سالمون از محبوبیت بالایی برخوردار هستند."
                : paramId === 5
                ? "گربه (Felis catus) یک گونه پستاندار گوشت‌خوار اهلی از خانواده گربه‌سانان است که به‌عنوان حیوان خانگی نگهداری می‌شود. این گونه تنها عضو اهلی‌شدهٔ خانوادهٔ خود است و از نظر رفتار، بدن انعطاف‌پذیر و توانایی شکارگری شناخته می‌شود."
                : paramId === 6
                ? "سگ (Canis lupus familiaris) یک گونه پستاندار گوشت‌خوار اهلی از خانواده سگ‌سانان است که به‌عنوان حیوان خانگی نگهداری می‌شود. این گونه زیرگونه‌ای اهلی‌شده از گرگ است و از نظر وفاداری، هوش بالا و توانایی‌های متنوعی مانند نگهبانی، شکار و همراهی شناخته می‌شود."
                : ""}
            </p>
          </div>
          <div className="flex relative w-full  flex-col justify-center items-center md:items-start">
            <span className="flex text-center md:text-center rounded-2xl text-xl font-bold gap-3 items-center">
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 10.7321C-0.333333 9.96225 -0.333333 8.03775 1 7.26795L13 0.339746C14.3333 -0.430054 16 0.532197 16 2.0718L16 15.9282C16 17.4678 14.3333 18.4301 13 17.6603L1 10.7321Z"
                  fill={
                    paramId === 1
                      ? "#ACD00E"
                      : paramId === 2
                      ? "#E84545"
                      : paramId === 3
                      ? "#43CA71"
                      : paramId === 4
                      ? "#C192FF"
                      : paramId === 5
                      ? "#F7941D"
                      : paramId === 6
                      ? "#3870FF"
                      : "none"
                  }
                />
              </svg>
              {t("type")}{" "}
              {paramId === 1
                ? t("sheep")
                : paramId === 2
                ? t("chicken")
                : paramId === 3
                ? t("cow")
                : paramId === 4
                ? t("fish")
                : paramId === 5
                ? t("cat")
                : paramId === 6
                ? t("dog")
                : ""}
            </span>
          </div>
          <div className="flex w-full gap-5">
            <div className="flex items-center justify-center w-1/5 rounded-lg px-4 py-1 shadow-lg bg-white">
              نوع 1
            </div>
            <div className="flex items-center justify-center w-1/5 rounded-lg px-4 py-1 shadow-lg bg-white">
              نوع 2
            </div>
            <div className="flex items-center justify-center w-1/5 rounded-lg px-4 py-1 shadow-lg bg-white">
              نوع 3
            </div>
            <div className="flex items-center justify-center w-1/5 rounded-lg px-4 py-1 shadow-lg bg-white">
              نوع 4
            </div>
          </div>
        </div>
        {categories.map((category) => {
          if (paramId === category.id) {
            return (
              <div key={category.id} className="flex flex-col items-center">
                <div className="w-80 h-80 bg-white relative rounded-full rounded-tl-none shadow-lg overflow-hidden">
                  <Image
                    src={category.image}
                    alt={category.title}
                    layout="fill"
                    objectFit="fill"
                    className="p-14 flex flex-col items-center"
                  />
                </div>
              </div>
            );
          }
        })}
      </section>

      <section dir="rtl" className="flex w-[100%] justify-center my-20 relative items-center">
        <div
          className="flex flex-col w-[38%] h-[350px] right-0 p-24 rounded-l-2xl text-white gap-8 absolute"
          style={{
            backgroundColor:
              paramId === 1
                ? "#ACD00E"
                : paramId === 2
                ? "#E84545"
                : paramId === 3
                ? "#43CA71"
                : paramId === 4
                ? "#C192FF"
                : paramId === 5
                ? "#F7941D"
                : paramId === 6
                ? "#3870FF"
                : "transparent",
          }}
        ></div>
        <div
          className="flex flex-col w-[25%] h-[100px] bottom-0 left-0 p-24 rounded-r-2xl text-white gap-8 absolute"
          style={{
            backgroundColor:
              paramId === 1
                ? "#ACD00E"
                : paramId === 2
                ? "#E84545"
                : paramId === 3
                ? "#43CA71"
                : paramId === 4
                ? "#C192FF"
                : paramId === 5
                ? "#F7941D"
                : paramId === 6
                ? "#3870FF"
                : "transparent",
          }}
        ></div>
        <div className="w-[70%]">
          <Slider {...settings2}>
            {[chickenProduct, sheepProduct, chickenProduct, cowsProduct].map((img, i) => (
              <div key={i} className="flex justify-center items-center">
                <div className="flex items-center justify-center p-4 h-auto">
                  <div className="flex flex-col w-[260px] bg-white justify-center items-center p-3 pb-5 rounded-lg gap-2 shadow-lg">
                    <div className="flex bg-[#EAF6FF] w-full justify-center rounded-lg">
                      <Image
                        src={img}
                        alt="product"
                        className="rounded-lg bg-[#EAF6FF] w-[220px] h-[220px]"
                      />
                    </div>
                    <span className="flex text-lg w-full">{t("noviHerb")}</span>
                    <span className="flex text-sm w-full">{t("noviHerbDesc")}</span>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      {paramId === 1 ? (
        <section id="section-4" className="w-full py-8 px-4 md:px-10 rounded-lg">
          <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
            سطوح قابل تحمل مایکوتوکسین ها در گوسفند
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
            <div className="p-6 flex items-center justify-center">
              <div className="flex w-full mx-auto">
                <div className="w-full md:w-1/3 flex justify-center">
                  <Image
                    src={sideCardSheep.src}
                    alt="cows"
                    width={350}
                    height={1000}
                    className="rounded-lg"
                  />
                </div>
                <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                  <thead>
                    <tr>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        نوع مایکوتوکسین
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        حداکثر سطح قابل تحمل
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        واحد | منبع
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        توضیحات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.toxin}
                        </td>
                        <td className="px-4 py-1 w-fit bg-[#ACD00E] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.max}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.source}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.desc}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : paramId === 2 ? (
        <section id="section-5" className="w-full py-8 px-4 md:px-10 rounded-lg">
          <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
            سطوح قابل تحمل مایکوتوکسین ها در طیور
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
            <div className="p-6 flex items-center justify-center">
              <div className="flex w-full mx-auto">
                <div className="w-full md:w-1/3 flex justify-center">
                  <Image
                    src={sideCardChicken.src}
                    alt="cows"
                    width={350}
                    height={1000}
                    className="rounded-lg"
                  />
                </div>
                <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                  <thead>
                    <tr>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        نوع مایکوتوکسین
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        حداکثر سطح قابل تحمل
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        واحد | منبع
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        توضیحات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.toxin}
                        </td>
                        <td className="px-4 py-1 w-fit bg-[#E84545] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.max}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.source}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.desc}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : paramId === 3 ? (
        <section id="section-3" className="w-full py-8 px-4 md:px-10 rounded-lg">
          <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
            سطوح قابل تحمل مایکوتوکسین ها در گاوهای شیری
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
            <div className="p-6 flex items-center justify-center">
              <div className="flex w-full mx-auto">
                <div className="w-full md:w-1/3 flex justify-center">
                  <Image
                    src={sideCardCow.src}
                    alt="cows"
                    width={350}
                    height={1000}
                    className="rounded-lg"
                  />
                </div>
                <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                  <thead>
                    <tr>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        نوع مایکوتوکسین
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        حداکثر سطح قابل تحمل
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        واحد | منبع
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        توضیحات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.toxin}
                        </td>
                        <td className="px-4 py-1 w-fit bg-[#43CA71] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.max}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.source}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.desc}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : paramId === 4 ? (
        <section id="section-8" className="w-full py-8 px-4 md:px-10 rounded-lg">
          <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
            سطوح قابل تحمل مایکوتوکسین ها در طیور
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
            <div className="p-6 flex items-center justify-center">
              <div className="flex w-full mx-auto">
                <div className="w-full md:w-1/3 flex justify-center">
                  <Image
                    src={sideCardFish.src}
                    alt="cows"
                    width={350}
                    height={1000}
                    className="rounded-lg"
                  />
                </div>
                <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                  <thead>
                    <tr>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        نوع مایکوتوکسین
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        حداکثر سطح قابل تحمل
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        واحد | منبع
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        توضیحات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.toxin}
                        </td>
                        <td className="px-4 py-1 w-fit bg-[#C192FF] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.max}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.source}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.desc}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : paramId === 5 ? (
        <section id="section-6" className="w-full py-8 px-4 md:px-10 rounded-lg">
          <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
            سطوح قابل تحمل مایکوتوکسین ها در طیور
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
            <div className="p-6 flex items-center justify-center">
              <div className="flex w-full mx-auto">
                <div className="w-full md:w-1/3 flex justify-center">
                  <Image
                    src={sideCardCat.src}
                    alt="cows"
                    width={350}
                    height={1000}
                    className="rounded-lg"
                  />
                </div>
                <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                  <thead>
                    <tr>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        نوع مایکوتوکسین
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        حداکثر سطح قابل تحمل
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        واحد | منبع
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        توضیحات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.toxin}
                        </td>
                        <td className="px-4 py-1 w-fit bg-[#F7941D] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.max}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.source}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.desc}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : paramId === 6 ? (
        <section id="section-7" className="w-full py-8 px-4 md:px-10 rounded-lg">
          <h2 className="text-center text-lg md:text-2xl font-bold text-[#003477]">
            سطوح قابل تحمل مایکوتوکسین ها در طیور
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center md:items-start gap-6">
            <div className="p-6 flex items-center justify-center">
              <div className="flex w-full mx-auto">
                <div className="w-full md:w-1/3 flex justify-center">
                  <Image
                    src={sideCardDog.src}
                    alt="cows"
                    width={350}
                    height={1000}
                    className="rounded-lg"
                  />
                </div>
                <table dir="rtl" className="w-full border-separate border-spacing-3 pb-3">
                  <thead>
                    <tr>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        نوع مایکوتوکسین
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        حداکثر سطح قابل تحمل
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        واحد | منبع
                      </th>
                      <th className="px-4 py-1 bg-[#D1ECFF] text-[#003477] text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                        توضیحات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-[#F9F9F9]"}>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.toxin}
                        </td>
                        <td className="px-4 py-1 w-fit bg-[#3870FF] text-white font-bold text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.max}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.source}
                        </td>
                        <td className="px-4 py-1 w-fit text-center rounded-lg shadow-[0px_0px_42px_17px_rgba(0,_0,_0,_0.1)]">
                          {row.desc}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ) : (
        "transparent"
      )}

      <div className="flex flex-col w-full justify-center items-center gap-10">
        <div className="flex flex-col w-fit justify-center items-start gap-10">
          <span className="text-3xl">گونه های دیگر</span>
          <div className="flex justify-center items-center gap-14">
            {categories.map((category) => (
              <div
                key={category.id}
                onClick={() => {
                  router.push(`/product-category/${category.id}`);
                }}
                className="flex flex-col items-center cursor-pointer"
              >
                <div className="w-16 h-16 md:w-28 md:h-28 relative rounded-lg overflow-hidden transition-transform duration-300 hover:scale-105">
                  <Image
                    src={category.image}
                    alt={category.title}
                    layout="fill"
                    objectFit="fill"
                    className="rounded-3xl bg-white p-3 flex flex-col items-center "
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="flex w-full justify-center items-center gap-28 text-lg py-8 px-4 md:px-10 rounded-lg">
        <div className="flex flex-col gap-8">
          <span className="text-3xl text-[#3C434A]">{t("needHelp")}</span>
          <span className="text-2xl text-[#3C434A]">{t("needHelpDesc")}</span>
        </div>
        <div className="flex flex-col gap-2.5">
          <button className="flex border-none bg-[#003477] text-2xl  px-8 py-5 text-white rounded-lg">
            {t("callUs")}
          </button>
          <button className="flex border-none bg-[#003477] text-2xl  px-8 py-5 text-white rounded-lg">
            {t("sendTicket")}
          </button>
        </div>
      </div>
    </div>
  );
}
